import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	warningsButtonLabel: {
		id: 'portfolio-3-portfolio.common.warning-details.warnings-button-label',
		defaultMessage: 'Warnings',
		description: 'It is the label of the "Warnings" icon button on the work items.',
	},
});
